module.exports = __webpack_public_path__ + "img/weapon_icon.ec198ce2.svg";